import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Manifesto from "@/components/site/Manifesto";
import Imperatives from "@/components/site/Imperatives";
import Framework from "@/components/site/Framework";
import Modules from "@/components/site/Modules";
import OnChainProof from "@/components/site/OnChainProof";
import Regions from "@/components/site/Regions";
import WhyAdvik from "@/components/site/WhyAdvik";
import Metrics from "@/components/site/Metrics";
import CaseVignette from "@/components/site/CaseVignette";
import Workshop from "@/components/site/Workshop";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <div className="relative">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Imperatives />
        <Framework />
        <Modules />
        <OnChainProof />
        <Regions />
        <WhyAdvik />
        <Metrics />
        <CaseVignette />
        <Workshop />
      </main>
      <Footer />
    </div>
  );
}
